import React from 'react';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { mdiFileMultiple, mdiPlay } from '@mdi/js';
import Icon from '@mdi/react';

const URLsSection = ({ hlsUrl, dashUrl, thumbnailUrl, onPlay, onCopy }) => {

    return (
        <Card className="mb-4">
            <CardBody>
                <CardTitle tag="h5" style={{ color: "#6691e7" }}> URLs</CardTitle>
                <hr />
                <FormGroup>
                    <Label for="hlsUrl">HLS URL</Label>
                    <Row>
                        <Col md={9}>
                            <Input
                                type="text"
                                id="hlsUrl"
                                value={hlsUrl}
                                readOnly
                                className="form-control"
                            />
                        </Col>
                        <Col md={1}>
                            <Button
                                style={{ backgroundColor: 'white', borderColor: 'white' }}
                                onClick={() => onPlay(hlsUrl)}
                                className="d-flex align-items-center justify-content-center"
                                disabled={!hlsUrl}
                                title="Play HLS"
                            >
                                <Icon path={mdiPlay} size={1} color="#50c3e6"/>
                            </Button>
                        </Col>
                        <Col md={1}>
                            <Button
                                style={{ backgroundColor: 'white', borderColor: 'white' }}
                                onClick={() => onCopy(hlsUrl)}
                                className="d-flex align-items-center justify-content-center"
                                disabled={!hlsUrl}
                                title="Copy HLS URL"
                            >
                                <Icon path={mdiFileMultiple} size={1} color="#6ada7d"/>
                            </Button>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Label for="dashUrl">DASH URL</Label>
                    <Row>
                        <Col md={9}>
                            <Input
                                type="text"
                                id="dashUrl"
                                value={dashUrl}
                                readOnly
                                className="form-control"
                            />
                        </Col>
                        <Col md={1}>
                            <Button
                                style={{ backgroundColor: 'white', borderColor: 'white' }}
                                onClick={() => onPlay(dashUrl)}
                                className="d-flex align-items-center justify-content-center"
                                disabled={!dashUrl}
                                title="Play DASH"
                            >
                                <Icon path={mdiPlay} size={1} color="#50c3e6"/>
                            </Button>
                        </Col>
                        <Col md={1}>
                            <Button
                               style={{ backgroundColor: 'white', borderColor: 'white' }}
                                onClick={() => onCopy(dashUrl)}
                                className="d-flex align-items-center justify-content-center"
                                disabled={!dashUrl}
                                title="Copy DASH URL"
                            >
                                <Icon path={mdiFileMultiple} size={1} color="#6ada7d"/>
                            </Button>
                        </Col>
                    </Row>
                </FormGroup>
                <FormGroup>
                    <Label for="thumbnailUrl">Thumbnail URL</Label>
                    <Row>
                        <Col md={9}>
                            <Input
                                type="text"
                                id="thumbnailUrl"
                                value={thumbnailUrl}
                                readOnly
                                className="form-control"
                            />
                        </Col>
                        <Col md={3}>
                            <Button
                                style={{ backgroundColor: 'white', borderColor: 'white' }}
                                onClick={() => onCopy(thumbnailUrl)}
                                className="d-flex align-items-center"
                                disabled={!thumbnailUrl}
                            >
                                <Icon path={mdiFileMultiple} size={1} color="#6ada7d"/>
                            </Button>
                        </Col>
                    </Row>
                </FormGroup>
            </CardBody>
        </Card>
    );
};

export default URLsSection;

